export enum DiscountType {
	percentage = 1,
	amount = 2,
}

export enum DiscountRepeatType {
	once = 1,
	forever = 2,
	duration = 3,
}

export enum DurationPeriodType {
	days = 1,
	weeks = 2,
	months = 3,
	years = 4,
}

export interface DiscountCode {
	id: number;
	code: string;
	name: string;
	description: string;
	discountTypeId: DiscountType;
	percentage: number | null;
	discountRepeatTypeId: DiscountRepeatType;
	durationPeriodTypeId: DurationPeriodType | null;
	durationCount: number | null;
	enabled: boolean;
	startDate: string;
	endDate: string | null;
	maxRedemptions: number | null;
}

export interface DiscountCodeWithCouponId extends DiscountCode {
	hyperlineCouponId: string;
}

export interface ExcludedProduct {
	id: string;
	name: string;
}
